import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Returns a back handler for AppPage. If either `mountPoint` or `classId` is
 * undefined, the handler is a no-op rather than navigating to
 * `/apps/remote/undefined/undefined`.
 */
export function useAppPageBack(mountPoint: string | undefined, classId: string | undefined) {
  const navigate = useNavigate();
  return useCallback(() => {
    if (!mountPoint || !classId) return;
    navigate(`/apps/remote/${mountPoint}/${classId}`);
  }, [navigate, mountPoint, classId]);
}
